/**
 * Footer Custom - Country Selector Flag Update
 * Updates the flag icon when country is changed
 */

if (!customElements.get('footer-country-selector')) {
  class FooterCountrySelector extends HTMLElement {
    constructor() {
      super();
      this.select = this.querySelector('select');
      this.flag = this.querySelector('.footer-custom__country-flag');

      if (this.select && this.flag) {
        this.select.addEventListener('change', this.updateFlag.bind(this));
      }
    }

    updateFlag(event) {
      const selectedOption = event.target.options[event.target.selectedIndex];
      const countryCode = selectedOption.value;

      if (this.flag) {
        this.flag.setAttribute('data-country', countryCode);
      }
    }
  }

  customElements.define('footer-country-selector', FooterCountrySelector);
}

/**
 * Footer Custom - Mobile Accordion
 */
document.addEventListener('DOMContentLoaded', () => {
  const initFooterAccordion = () => {
    const titles = document.querySelectorAll('.footer-custom__title');

    titles.forEach(title => {
      // Remove existing listener if any (to avoid duplicates if re-initialized)
      title.removeEventListener('click', toggleAccordion);
      title.addEventListener('click', toggleAccordion);
    });
  };

  const toggleAccordion = (event) => {
    // Only apply on mobile (width <= 768px)
    if (window.innerWidth > 768) return;

    const title = event.currentTarget;
    const column = title.closest('.footer-custom__col');

    if (!column) return;

    const isActive = column.classList.contains('is-active');

    // Check if accordion mode is enabled
    const section = column.closest('.footer-custom__links');
    const isAccordion = section && section.getAttribute('data-accordion') === 'true';

    if (isAccordion) {
      // Close all other accordions in the same section
      section.querySelectorAll('.footer-custom__col').forEach(col => {
        if (col !== column) {
          col.classList.remove('is-active');
        }
      });
    }

    // Toggle current
    column.classList.toggle('is-active');
  };

  // Initialize
  initFooterAccordion();

  // Re-initialize on window resize to ensure it works if switching orientations/sizes
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      // We don't necessarily need to re-init listeners, but we might want to
      // clear 'is-active' classes if we go back to desktop
      if (window.innerWidth > 768) {
        document.querySelectorAll('.footer-custom__col.is-active').forEach(col => {
          col.classList.remove('is-active');
        });
      }
    }, 250);
  });
});

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  const countryWrappers = document.querySelectorAll('.footer-custom__country-wrap');

  countryWrappers.forEach(wrapper => {
    if (!wrapper.closest('footer-country-selector')) {
      const customElement = document.createElement('footer-country-selector');
      wrapper.parentNode.insertBefore(customElement, wrapper);
      customElement.appendChild(wrapper);
    }
  });
});
